import * as types from "../types/offlineOrders"

const initialState = []

const offlineOrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_OFFLINE_ORDERS:
      return [...action.offlineOrders]
    case types.ADD_OFFLINE_ORDER:
      return [action.newOfflineOrder, ...state]
    case types.REPLACE_OFFLINE_ORDER:
      return state.map(o =>
        o.offlineOrderId === action ? action.offlineOrder : o
      )
    case types.EDIT_OFFLINE_ORDER:
      return state.map(o =>
        o.offlineOrderId === action.offlineOrderId
          ? { ...o, ...action.offlineOrder }
          : o
      )
    case types.DELETE_OFFLINE_ORDER:
      return state.filter(o =>
        o.offlineOrderId !== action.offlineOrderId
      )
    case types.DELETE_ALL_OFFLINE_ORDERS:
      return []
    default:
      return state
  }
}

export default offlineOrdersReducer